import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	automationButton: {
		id: 'horizontal-nav-header.extra-components-far.automation-button.automation-button',
		defaultMessage: 'Automation',
		description: 'Tooltip on automation button shown in the project contextual navigation',
	},
});
